import PrimaryTitle from "./PrimaryTitle";
import PrimaryCaption from "./PrimaryCaption";
import InputAlertTitle from "./InputAlertTitle";
import PrimarySubtitle from "./PrimarySubtitle";
import SubtitleLight from "./SubtitleLight";
import LinkAlert from "./LinkAlert";
import LinkIndigo from "./LinkIndigo";
import SubtitleLightIndigo from "./SubtitleLightIndigo";
import SubtitleItalic from "./SubtitleItalic";
import CaptionLight from "./CaptionLight";
import SubtitleCapBold from "./SubtitleCapBold";
import SubHeading from "./SubHeading";
import BodyTitle from "./BodyTitle";
import BodyTitleGray from "./BodyTitleGray";
import SubtitleIndigo from "./SubtitleIndigo";

export {
    PrimaryTitle,
    PrimaryCaption,
    InputAlertTitle,
    PrimarySubtitle,
    SubtitleLight,
    LinkAlert,
    LinkIndigo,
    SubtitleLightIndigo,
    SubtitleItalic,
    CaptionLight,
    SubtitleCapBold,
    SubHeading,
    BodyTitle,
    BodyTitleGray,
    SubtitleIndigo
}